import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MaskedField from './MaskedField';

function CpfField({ value, onChange, error, ...rest }) {
  const { t } = useTranslation()

  return (
    <MaskedField
      mask={'999.999.999-999'}
      value={value}
      onChange={onChange}
      error={error}
      helperText={error ? t('default.cpfFieldError') : ''}
      maskOptions={{
        alwaysShowMask: false,
        maskChar: ''
      }}
      {...rest}
    />
  )
}

CpfField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool
}

CpfField.defaultProps = {
  value: '',
  onChange: () => true,
  error: false
}

export default CpfField